/**
 * @typedef {Object} Highlight
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} image      Path relative to public/.
 * @property {string} linkTo     Route the card's call to action points at.
 * @property {string} linkLabel
 */

/** The two welcome cards on the home page. @type {Highlight[]} */
export const HIGHLIGHTS = [
  {
    id: 'trusted-vets',
    title: 'Trusted Vets',
    description:
      'Our team consists of certified veterinarians experienced in all things animal care. With professionals specializing in surgery, dermatology, cancer treatment, and grooming, you can be sure your pets will be well taken care of.',
    image: 'images/welcome/1.png',
    linkTo: '/Team',
    linkLabel: 'Meet Our Team',
  },
  {
    id: 'modern-facilities',
    title: 'Modern Facilities',
    description:
      'Our veterinary hospitals were designed with great attention to detail and loads of passion, ensuring your pets have accesses to anything they need. Both you and your pets will feel right at home in any of our locations.',
    image: 'images/welcome/2.png',
    linkTo: '/Locations',
    linkLabel: 'View Our Locations',
  },
];
